export const environment = {
  production: true,
  state: 'az-deploy',
  netApiUrl: '/prod/api',
  API_BASE_PATH: '/prod/backend-rest',
  isProduction: 'true',
  appNameInNavigationBar: '',
  appNameColorNavigationBar: '',
  appVersion: '1.41.0',
  legacyModules: 'disabled',
  simapUrl: 'https://www.simap.ch',
  azureAuthApi: {
    endpoint: '/prod/api/User/AzureAdLogin',
  },
  showLoginWithMicrosoft: 'enabled',
  msalConfig: {
    clientId: 'a081b5ac-1d16-4a05-a310-75ea1143095b',
    redirectUri: '/prod/auth',
    postLogoutRedirectUri: '/prod',
    b2cPolicies: {
      names: {
        signUpSignIn: 'B2C_1A_SIGNUP_SIGNIN',
      },
      authorities: {
        signUpSignIn: {
          authority:
            'https://xatb2c.b2clogin.com/xatb2c.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN',
        },
      },
      authorityDomain: 'xatb2c.b2clogin.com',
    },
    protectedResources: {
      api: {
        scopes: {
          read: ['https://xatb2c.onmicrosoft.com/AzureAuthAPI/Auth.Read'],
        },
      },
    },
  },
  simapOAuthConfig: {
    enabled: true,
    issuer: 'https://www.simap.ch/auth/realms/simap',
    redirectUri: window.location.origin + '/prod/',
    clientId: 'xatena-spa',
    responseType: 'code',
    scope: 'openid profile',
    showDebugInformation: false,
  },
};
